// extracted by mini-css-extract-plugin
export default {"title":"styles_title__qRAoJ","flex":"styles_flex__AY2nT","block":"styles_block__qi1zs","icon":"styles_icon__JzQwL"};